export default __webpack_public_path__ + "static/media/calendar-icon.ed4d59e4.svg";